import { getFromSecureStore } from "@utils/index";
import * as LocalAuthentication from "expo-local-authentication";
import { useState } from "react";

export const useBiometricType = () => {
  const [biometricType, setBiometricType] = useState<string | null>(null);
  const [isBiometricEnabled, setIsBiometricEnabled] = useState(false);
  const supportedBiometrics = async () => {
    const value = await getFromSecureStore("biometricEnabled");
    if (value) {
      setIsBiometricEnabled(value === "true");
    }

    const supportedTypes =
      await LocalAuthentication.supportedAuthenticationTypesAsync();

    if (
      supportedTypes.includes(
        LocalAuthentication.AuthenticationType.FACIAL_RECOGNITION
      ) &&
      supportedTypes.includes(
        LocalAuthentication.AuthenticationType.FINGERPRINT
      )
    ) {
      setBiometricType("both");
    } else {
      if (
        supportedTypes.includes(
          LocalAuthentication.AuthenticationType.FACIAL_RECOGNITION
        )
      ) {
        setBiometricType("face");
      } else if (
        supportedTypes.includes(
          LocalAuthentication.AuthenticationType.FINGERPRINT
        )
      ) {
        setBiometricType("fingerprint");
      } else {
        setBiometricType(null);
      }
    }
  };

  return { biometricType, supportedBiometrics, isBiometricEnabled };
};
